import { render, staticRenderFns } from "./TraineeSponsorDetails.vue?vue&type=template&id=13ba1b12&"
import script from "./TraineeSponsorDetails.vue?vue&type=script&lang=js&"
export * from "./TraineeSponsorDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports